import React from "react";
import ClipboardWhite from "../icons/clipboard-white.svg";
import ClipboardGrey from "../icons/clipboard-grey.svg";

const TermsConditionStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? ClipboardWhite : ClipboardGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Terms & Conditions Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};

export default TermsConditionStepIcon;
